import Swal from "sweetalert2";

export const showSuccessDialog = (message) =>
  Swal.fire({
    title: "Success",
    text: message,
    icon: "success",
    confirmButtonText: "OK",
    confirmButtonColor: "#2679B8",
  });

export const showErrorDialog = (message) =>
  Swal.fire({
    title: "Error",
    text: message,
    icon: "error",
    confirmButtonText: "OK",
    confirmButtonColor: "#2679B8",
  });

export const showDialog = (
  message,
  title = "Info",
  icon = "info",
  confirmText = "OK"
) =>
  Swal.fire({
    title: title,
    text: message,
    icon: icon,
    confirmButtonText: confirmText,
    confirmButtonColor: "#2679B8",
  });

export const showConfirmDialog = (message) =>
  Swal.fire({
    title: "Confirm",
    text: message,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#2679B8",
  });

export const showDeleteDialog = (message) =>
  Swal.fire({
    title: "Delete",
    html: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#2679B8",
  });

export const showVehicleDialog = (message) =>
  Swal.fire({
    title: "Info",
    text: message,
    icon: "info",
    showCancelButton: true,
    confirmButtonText: "Create Vehicle",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#2679B8",
  });
